import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["className", "arrowPlacement"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { styled, Tooltip, tooltipClasses } from '@mui/material';
import { colors, pxToRem } from '@themes';
import { jsx as _jsx } from "react/jsx-runtime";
var StyledTooltip = styled(function (_ref) {
  var className = _ref.className,
    arrowPlacement = _ref.arrowPlacement,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsx(Tooltip, _objectSpread(_objectSpread({}, props), {}, {
    classes: {
      popper: className
    }
  }));
})(function (_ref2) {
  var theme = _ref2.theme,
    arrowPlacement = _ref2.arrowPlacement;
  var styles = _defineProperty(_defineProperty({}, "& .".concat(tooltipClasses.tooltip), _objectSpread(_objectSpread({}, theme.typography.body3), {}, {
    padding: theme.spacing(1.5),
    backgroundColor: colors.white,
    color: colors.mirage,
    boxShadow: '0px 0px 1.3px rgba(44, 45, 46, 0.25), 0px 20px 13px rgba(52, 56, 67, 0.03), 0px 8px 5px rgba(52, 56, 67, 0.08)'
  })), "& .".concat(tooltipClasses.arrow), {
    color: colors.white,
    '&:before': {
      border: "1px solid ".concat(colors.mirage),
      boxShadow: '0px 0px 1.3px rgba(44, 45, 46, 0.25), 0px 20px 13px rgba(52, 56, 67, 0.03), 0px 8px 5px rgba(52, 56, 67, 0.08)'
    }
  });
  switch (arrowPlacement) {
    case 'bottom-start':
    case 'top-start':
      {
        styles = _objectSpread(_objectSpread({}, styles), _defineProperty({}, "& .".concat(tooltipClasses.arrow), _objectSpread(_objectSpread({}, styles["& .".concat(tooltipClasses.arrow)]), {}, {
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          transform: "translate(".concat(pxToRem(10), ", 0px)!important")
        })));
        break;
      }
    case 'bottom-end':
    case 'top-end':
      {
        styles = _objectSpread(_objectSpread({}, styles), _defineProperty({}, "& .".concat(tooltipClasses.arrow), _objectSpread(_objectSpread({}, styles["& .".concat(tooltipClasses.arrow)]), {}, {
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          transform: "translate(".concat(pxToRem(32), ", 0px)!important")
        })));
        break;
      }
    case 'left-start':
    case 'right-start':
      {
        styles = _objectSpread(_objectSpread({}, styles), _defineProperty({}, "& .".concat(tooltipClasses.arrow), _objectSpread(_objectSpread({}, styles["& .".concat(tooltipClasses.arrow)]), {}, {
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          transform: "translate(0px, ".concat(pxToRem(6), ")!important")
        })));
        break;
      }
    case 'left-end':
    case 'right-end':
      {
        styles = _objectSpread(_objectSpread({}, styles), _defineProperty({}, "& .".concat(tooltipClasses.arrow), _objectSpread(_objectSpread({}, styles["& .".concat(tooltipClasses.arrow)]), {}, {
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          transform: "translate(0px, ".concat(pxToRem(24), ")!important")
        })));
        break;
      }
    default:
      {
        styles = _objectSpread(_objectSpread({}, styles), _defineProperty({}, "& .".concat(tooltipClasses.arrow), _objectSpread({}, styles["& .".concat(tooltipClasses.arrow)])));
        break;
      }
  }
  return styles;
});
export { StyledTooltip };